<div class="product-listing-form-container relative w-full h-full">
  <app-add-form
    #addForm
    [title]="config().title"
    [formFields]="config().formFields"
    [headerActions]="config().headerActions"
    [tableSections]="tableSections()"
    [editMode]="editMode()"
    [viewMode]="viewMode()"
    [initialData]="formData()"
    [loading]="loading()"
    (formValueChanges)="onFormValueChanges($event)"
    (formAction)="onFormAction($event)"
    (tableAction)="onTableAction($event)"
  ></app-add-form>
  
  <!-- Loading spinner overlay (page content only) -->
  @if (loading()) {
    <div class="loading-overlay absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
      <div class="flex flex-col items-center gap-4">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <p class="text-sm text-gray-600 font-medium">
          {{ 'common.messages.loading' | translate }}
        </p>
      </div>
    </div>
  }
</div>

<p-toast></p-toast>
